export default "__VITE_ASSET__B7a3N7LI__"